import { IResourceComponentsProps, useNavigation } from "@refinedev/core";
import { Create, useForm } from "@refinedev/antd";
import { Form } from "antd";

import { FormList } from "./form";
import { ICredential, IStore } from "interfaces";
import { dataProvider } from "dataProvider";

export const CredentialCreate: React.FC<IResourceComponentsProps> = () => {
  const { list } = useNavigation();

  const { formProps, saveButtonProps, queryResult } = useForm<ICredential>({
    warnWhenUnsavedChanges: false,
  });

  const addCredential = async (variables: any) => {
    await dataProvider.create({
      resource: "credentials",
      variables,
      metadata: undefined,
    });

    list("credentials");
  };

  return (
    <Create
      isLoading={queryResult?.isFetching}
      saveButtonProps={saveButtonProps}
    >
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => addCredential(values)}
      >
        <FormList formProps={formProps} type="create" />
      </Form>
    </Create>
  );
};
